// extracted by mini-css-extract-plugin
export var callCard = "_k8-0";
export var callMessageButton = "_k8-1";
export var helpIcon = "_k8-3";
export var helpIconContainer = "_k8-4";
export var verticalDivider = "_k8-2";